import {gql} from 'apollo-angular';

export const GET_GAME_TROPHY_HUNT_SCHOOL_CLASS_ENTRY = gql`
  query GetGameTrophyHuntSchoolClass($schoolClassId: Int!) {
    getGameTrophyHuntSchoolClassEntry(gameTrophyHuntSchoolClassID: $schoolClassId) {
      id
      step
      description
      wordsLength
    }
  }
`;
